( function ( $ ) {
	$( document ).on( 'click', '.scroll-to-top', function () {
		$( 'html, body' ).animate(
			{
				scrollTop: 0,
			},
			500
		);
	} );

	// Handle scroll event to show/hide button
	const scrollButton = $( '.scroll-to-top' );

	$( window ).on( 'scroll', function () {
		const windowHeight = $( window ).height();
		const scrollTop = $( window ).scrollTop();

		if ( scrollTop > windowHeight ) {
			scrollButton.addClass( 'is-visible' );
		} else {
			scrollButton.removeClass( 'is-visible' );
		}
	} );
} )( jQuery );
